'use client';

import React from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

interface StudentBodyStepProps {
  control: Control<any>;
  errors?: any;
  isEdit: boolean;
  // Campus size and neighborhood crime info are business-only.
  isBusiness?: boolean;
}

export default function StudentBodyStep({
  control,
  isBusiness = false,
}: StudentBodyStepProps) {
  return (
    <div className="space-y-1">
      {isBusiness && (
        <FormField
          control={control}
          name="campusSize"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="xl:text-sm ml-1">
                Campus Size (acres)
              </FormLabel>

              <FormControl>
                <Input
                  type="number"
                  step="any"
                  value={field.value ?? ''}
                  min={0}
                  className="placeholder:text-muted-foreground placeholder:text-sm"
                  onChange={(e) =>
                    field.onChange(
                      e.currentTarget.value === ''
                        ? null
                        : parseFloat(e.currentTarget.value)
                    )
                  }
                  placeholder="12.5"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={control}
        name="culture"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="xl:text-sm ml-1">Culture</FormLabel>
            <FormControl>
              <Textarea
                {...field}
                placeholder="Describe the school culture"
                rows={3}
                className="max-w-full min-h-[80px] resize-none placeholder:text-muted-foreground placeholder:text-sm"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {isBusiness && (
        <FormField
          control={control}
          name="neighborhoodCrimeInfo"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="xl:text-sm ml-1">
                Neighborhood Crime Information
              </FormLabel>

              <FormControl>
                <Textarea
                  {...field}
                  placeholder="Share any safety or crime-related information about your neighborhood"
                  rows={2}
                  className="max-w-full min-h-[80px] resize-none placeholder:text-muted-foreground placeholder:text-sm"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={control}
        name="clubs"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="xl:text-sm ml-1">Clubs Offered</FormLabel>

            <FormControl>
              <Textarea
                {...field}
                placeholder="Book Club, STEM, Art"
                rows={2}
                className="max-w-full min-h-[80px] resize-none placeholder:text-muted-foreground placeholder:text-sm"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="sports"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="xl:text-sm ml-1">Sports Offered</FormLabel>

            <FormControl>
              <Textarea
                {...field}
                placeholder="soccer, gymnastics, ballet"
                rows={2}
                className="max-w-full min-h-[80px] resize-none placeholder:text-muted-foreground placeholder:text-sm"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
